import React from 'react';
import PropTypes from 'prop-types';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const BOX_SIZES = {
  xs: 5,
  sm: 8,
  md: 10,
  lg: 13,
  xl: 17,
};

const useStyles = buildUseStyles('Image', theme => ({
  root: {
    height: props => (BOX_SIZES[props.boxSize]
      ? theme.spacing(BOX_SIZES[props.boxSize])
      : 'auto'),
    width: props => (BOX_SIZES[props.boxSize]
      ? theme.spacing(BOX_SIZES[props.boxSize])
      : '100%'),
  },
}));

const Image = ({ alt, boxSize, src }) => {
  const classes = useStyles({ boxSize });
  return <Box alt={alt} className={classes.root} component="img" src={src} />;
};

Image.defaultProps = {
  boxSize: undefined,
};

Image.propTypes = {
  alt: PropTypes.string.isRequired,
  boxSize: PropTypes.oneOf(Object.keys(BOX_SIZES)),
  src: PropTypes.string.isRequired,
};

export default Image;
